export default "https://cdn.questicon.mathletics.com/assets/images/zoom-in-a3e8eb992fb94ce32d088cc84f787cb6.svg";